// extracted by mini-css-extract-plugin
module.exports = {"primary-page-title":"primary-page-title_primary-page-title__YrHHi","primary-page-title--tooltip":"primary-page-title_primary-page-title--tooltip__e0Q0d"};